// resolve all requests with latest response
// each new request postpones resolving previous  requests with pending status

export const percolateRequest = (fn) => {
  let _current = null;

  return (params) => {
    _current = fn(params);
    return wait(_current);
  };

  async function wait(p) {
    let data = null;
    let error = null;
    try {
      data = await p;
    } catch (e) {
      error = e;
    } finally {
      if (_current === p) {
        return error ? Promise.reject(error) : data;
      } else {
        return wait(_current);
      }
    }
  }
};
